// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h1 {
    font-size: 26px;
    color: var(--black-color) !important;
    font-weight: 900;
}

.createBtn {
    background-color: var(--primary-color) !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 6px !important;
    color: var(--white-color) !important;
    padding: 0.8rem 2rem 0.8rem 2rem !important;
    border: none !important;
    cursor: pointer !important;
}

.resetbtn {
    background-color: var(--white-color) !important;
    text-transform: capitalize !important;
    font-weight: 800 !important;
    border-radius: 6px !important;
    color: var(--primary-color) !important;
    padding: 0.8rem 2rem 0.8rem 2rem !important;
    border: 1px solid var(--primary-color) !important;
    cursor: pointer !important;
    box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/userManagement/userType/addUserType/addUserType.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,qCAAqC;IACrC,2BAA2B;IAC3B,6BAA6B;IAC7B,oCAAoC;IACpC,2CAA2C;IAC3C,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;IAC/C,qCAAqC;IACrC,2BAA2B;IAC3B,6BAA6B;IAC7B,sCAAsC;IACtC,2CAA2C;IAC3C,iDAAiD;IACjD,0BAA0B;IAC1B,2BAA2B;AAC/B","sourcesContent":[".h1 {\n    font-size: 26px;\n    color: var(--black-color) !important;\n    font-weight: 900;\n}\n\n.createBtn {\n    background-color: var(--primary-color) !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 6px !important;\n    color: var(--white-color) !important;\n    padding: 0.8rem 2rem 0.8rem 2rem !important;\n    border: none !important;\n    cursor: pointer !important;\n}\n\n.resetbtn {\n    background-color: var(--white-color) !important;\n    text-transform: capitalize !important;\n    font-weight: 800 !important;\n    border-radius: 6px !important;\n    color: var(--primary-color) !important;\n    padding: 0.8rem 2rem 0.8rem 2rem !important;\n    border: 1px solid var(--primary-color) !important;\n    cursor: pointer !important;\n    box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
